import type { FC, ReactNode } from 'react';
import cx from 'classnames';

import type { IconComponentFunction } from '@motorway/mw-highway-code';
import { InfoIcon } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import { applyTestIdData } from 'Utilities/helpers';

import styles from './SectionState.module.scss';

interface SectionStateProps {
	className?: string;
	description: ReactNode;
	icon?: IconComponentFunction;
	testId?: string;
	title: ReactNode;
}

export const SectionState: FC<SectionStateProps> = ({ className, description, icon, testId, title }) => {
	const Icon = icon || InfoIcon;
	return (
		<div
			className={cx(styles.container, className)}
			{...applyTestIdData(testId || cypressIds.containers.pageSectionState)}
		>
			<Icon size="large" />
			<span className={styles.title} {...applyTestIdData(cypressIds.containers.pageSectionStateTitle)}>
				{title}
			</span>
			<p {...applyTestIdData(cypressIds.containers.pageSectionStateDescription)}>{description}</p>
		</div>
	);
};
